import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import {
    chain,
    FindWarehouseData,
} from "@insite/client-framework/Store/Data/RealTimeInventory/Handlers/GetRealTimeWarehouseInventory";

replaceInChain(chain, FindWarehouseData, props => {
    props.result = {
        errorMessage: "Inventory is not currently available",
    };

    if (
        props.apiResult &&
        props.apiResult.inventoryWarehousesDtos &&
        props.apiResult.inventoryWarehousesDtos.length > 0
    ) {
        const inventoryWarehousesDto = props.apiResult.inventoryWarehousesDtos.find(
            o => o.unitOfMeasure.toLowerCase() === props.parameter.unitOfMeasure.toLowerCase(),
        );

        if (inventoryWarehousesDto && inventoryWarehousesDto.warehouseDtos) {
            props.result = {
                warehouses: inventoryWarehousesDto.warehouseDtos,
                errorMessage: "",
            };
        }
    } else if (
        props.apiResult &&
        props.apiResult.inventoryAvailabilityDtos &&
        props.apiResult.inventoryAvailabilityDtos.length > 0
    ) {
        const inventoryAvailabilityDtos = props.apiResult.inventoryAvailabilityDtos;
        props.result = {
            warehouses: inventoryAvailabilityDtos,
            errorMessage: "",
        } as any;
    }
});
